import { Link2, Check } from 'lucide-react'
import { useCallback, useState } from 'react'

export default function CopyLinkButton({ className = '' }: { className?: string }) {
  const [copied, setCopied] = useState(false)

  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(window.location.href)
      setCopied(true)
      window.setTimeout(() => setCopied(false), 2000)
    } catch {
      window.prompt('Copy link:', window.location.href)
    }
  }, [])

  return (
    <button
      type="button"
      onClick={() => void handleCopy()}
      className={`inline-flex items-center gap-2 text-sm font-medium rounded-lg px-3 py-2 min-h-[44px] bg-gray-800/90 border border-gray-700 text-gray-200 hover:bg-gray-800 ${className}`}
      title="Copy page link"
    >
      {copied ? <Check className="w-4 h-4 text-green-400" /> : <Link2 className="w-4 h-4" />}
      {copied ? 'Copied' : 'Copy link'}
    </button>
  )
}
